import { useTranslation } from 'react-i18next';
import { IconCalendar, IconCheckCircle, IconLessonAside } from '../../../../app/components/Icons';

const POINTS = ['schedule', 'manage', 'growth'] as const;

export function LessonCreateAside() {
  const { t } = useTranslation();

  return (
    <aside className="mentor-lessons__aside">
      <span className="mentor-lessons__aside-badge">
        <IconCalendar />
      </span>
      <h2>{t('lesson.aside_title')}</h2>
      <p>{t('lesson.aside_body')}</p>
      <ul className="mentor-lessons__points">
        {POINTS.map((point) => (
          <li key={point}>
            <IconCheckCircle />
            <span>
              <strong>{t(`lesson.aside_${point}`)}</strong>
              {t(`lesson.aside_${point}_hint`)}
            </span>
          </li>
        ))}
      </ul>
      <div className="mentor-lessons__aside-art">
        <IconLessonAside />
      </div>
    </aside>
  );
}
